module.exports = __webpack_public_path__ + "media/tape-nav/personal-switch-account-icon-b9620e46.svg";